const Badge = ({ color, children }) => {
  return (
    <span
      className={`inline-flex items-center gap-x-1 rounded-tremor-small bg-${color}-100 px-2 py-1 text-tremor-label font-semibold text-${color}-800 dark:bg-${color}-400/20 dark:text-${color}-500`}
    >
      {children}
    </span>
  );
};

export default Badge;
